import { backgroundImages } from "../backgrounds";

interface SubtleBackgroundProps {
  /** Index into the shared background collection; different pages can pick different photos. */
  imageIndex?: number;
}

/**
 * Discrete static background for non-home pages: a single softly-blurred
 * photo with a light veil, so cards and text stay readable.
 */
const SubtleBackground = ({ imageIndex = 6 }: SubtleBackgroundProps) => {
  if (backgroundImages.length === 0) return null;
  const src = backgroundImages[imageIndex % backgroundImages.length];
  return (
    <div className="subtle-bg" aria-hidden="true">
      <div className="subtle-bg-image" style={{ backgroundImage: `url(${src})` }} />
      <div className="subtle-bg-veil" />
    </div>
  );
};

export default SubtleBackground;
